export enum VarianceType {
    VARIANCE_AMOUNT = "varianceAmount",
    VARIANCE_PERCENT = "variancePercent"
}